import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {createImgIn, setElementInnerHTML} from '../ui_utils/DomUtils.ts'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {createTooltipIn} from '../ui_utils/TooltipUtils.ts'

export class UIProfileOverviewController {
    private readonly username = document.getElementById('sticky_player_info_username') as HTMLHeadingElement | null
    private readonly pointsStat = document.getElementById('points_stat') as HTMLHeadingElement
    private readonly winRatioStat = document.getElementById('win_ratio_stat') as HTMLHeadingElement
    private readonly pgStat = document.getElementById('pg_stat') as HTMLHeadingElement
    private readonly karmaStat = document.getElementById('karma_stat') as HTMLHeadingElement

    private readonly totalGamesStat = document.getElementById('total_games_stat') as HTMLLinkElement

    setStats(data: AjaxDataTypes.PublicProfileDataOverview) {
        if(this.username != null) this.username.innerText = data.username
        this.pointsStat.innerText = String(data.gameData.pointsInLast100Games)
        this.winRatioStat.innerText = data.gameData.winPercent
        this.pgStat.innerText = data.gameData.pointsPerGame
        this.karmaStat.innerText = data.karma
        this.totalGamesStat.innerText = String(data.gameData.totalGames)

        UIProfileOverviewController.setBadges(data.userId)
    }

    // Create legitimate system when more badges are added; static for now
    private static setBadges(userId: string) {
        const badgesContainer = document.getElementById('user-badges-container') as HTMLDivElement
        setElementInnerHTML(badgesContainer, {key: 'strings:colonistCommon.utils.emptyString'})

        const season11TournamentWinnerId = '19719305'
        const tournament4pWinnerIds = ['94451747', '56604020', '51304747', '96441641', '61890847', '55031713', '99019802', '52067869', '99218961']

        if(userId == season11TournamentWinnerId) UIProfileOverviewController.createBadge(badgesContainer, LobbyImage.TournamentS11First, {key: 'strings:profilePage.overview.badges.season11TournamentFirstTooltip'}, 'tournament-s11-first')
        if(tournament4pWinnerIds.includes(userId)) UIProfileOverviewController.createBadge(badgesContainer, LobbyImage.Tournament4P, {key: 'strings:profilePage.overview.badges.tournament4pTooltip'}, 'tournament-4p')
    }

    private static createBadge(badgesContainer: HTMLDivElement, badgeImage: LobbyImage, tooltipText: TranslationObject, badgeName: string) {
        const badge = createImgIn(badgesContainer, badgeImage)
        createTooltipIn(badge, tooltipText, 'right')
    }
}
